import axiosInstance from './Instance/axiosInstance';
import { Role } from '../types/roles';

export const getRoles = async (): Promise<Role[]> => {
    const res = await axiosInstance.get('/roles');
    return res.data.roles;
};

export const createRole = async (role: Role): Promise<Role> => {
    const res = await axiosInstance.post('/roles', role);
    return res.data;
};

export const updateRole = async (id: string, role: Role): Promise<Role> => {
    const res = await axiosInstance.put(`/roles/${id}`, role);
    return res.data;
};

export const deleteRole = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/roles/${id}`);
};